export const authLoginFrameTitle = 'misc.auth.account.login.qr_code';
export const authLoginFrameContents = [
  'misc.auth.account.login.open_app',
  'misc.auth.account.login.enter_scan',
  'misc.auth.account.login.scan_to_login',
];
